import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgToggleModule } from '@nth-cloud/ng-toggle';

import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { config } from '../environments/environment';
import { AppComponent, AppHttpInterceptor } from './app.component';
import { SurerouteTestObjectComponent } from './component/akamai/sureroute-test-object/sureroute-test-object.component';
import { AdditionalSectionCardComponent } from './component/card/additional-section-card/additional-section-card/additional-section-card.component';
import { APIInformationCardComponent } from './component/card/api-information-card/api-information-card.component';
import { APIReferenceManagementCardComponent } from './component/card/api-reference-management-card/api-reference-management-card.component';
import { BenefitCardComponent } from './component/card/benefit-card/benefit-card.component';
import { ConnectCardComponent } from './component/card/connect-card/connect-card.component';
import { CreditVoucherCardComponent } from './component/card/credit-voucher-card/credit-voucher-card.component';
import { FaqCardComponent } from './component/card/faq-card/faq-card.component';
import { LoggingInCardComponent } from './component/card/logging-in-card/logging-in-card.component';
import { NdcRegistrationCardComponent } from './component/card/ndc-registration-card/ndc-registration-card.component';
import { NdcRegistrationManualCardComponent } from './component/card/ndc-registration-manual-card/ndc-registration-manual-card.component';
import { NdcRegistrationsSaleshubCardComponent } from './component/card/ndc-registrations-saleshub-card/ndc-registrations-saleshub-card.component';
import { NewsSectionCardComponent } from './component/card/news-section-card/news-section-card.component';
import { NewsUpdateCardComponent } from './component/card/news-update-card/news-update-card.component';
import { SupportCardComponent } from './component/card/support-card/support-card.component';
import { UsefulLinkCardComponent } from './component/card/useful-link-card/useful-link-card.component';
import { UserCardComponent } from './component/card/user-card/user-card.component';
import { WhereDoIRegisterCardComponent } from './component/card/where-do-i-register-card/where-do-i-register-card.component';
import { AdditionalContentPageComponent } from './component/page/additional-content-page/additional-content-page.component';
import { ApiDocsPageComponent } from './component/page/api-docs-page/api-docs-page.component';
import { APIInformationPageComponent } from './component/page/api-information-page/api-information-page.component';
import { Ndc21ApiReferenceComponent } from './component/page/ndc-21-api-reference/ndc-21-api-reference.component';
import { ConnectPageComponent } from './component/page/connect-page/connect-page.component';
import { ConsentMoreinfoPageComponent } from './component/page/consent-moreinfo-page/consent-moreinfo-page.component';
import { CookiesPolicyPageComponent } from './component/page/cookies-policy-page/cookies-policy-page.component';
import { ContactUsPageComponent } from './component/page/contact-us-page/contact-us-page.component';
import { FaqPageComponent } from './component/page/faq-page/faq-page.component';
import { FileUploadComponent } from './component/page/file-upload/file-upload.component';
import { NdcCreditVoucherIssuancePageComponent } from './component/page/forms/ndc-credit-voucher-issuance-page/ndc-credit-voucher-issuance-page.component';
import { NdcCreditVoucherRedemptionPageComponent } from './component/page/forms/ndc-credit-voucher-redemption-page/ndc-credit-voucher-redemption-page.component';
import { NdcVoucherLogsPageComponent } from './component/page/forms/ndc-voucher-logs-page/ndc-voucher-logs-page.component';
import { OrderChangeNotifRegistrationPageComponent } from './component/page/forms/order-change-notif-registration-page/order-change-notif-registration-page.component';
import { AdditionalPageAccordianSectionComponent } from './component/page/group/addiotional-page/additional-page-accordian-section/additional-page-accordian-section.component';
import { AdditionalPageCarouselSectionComponent } from './component/page/group/addiotional-page/additional-page-carousel-section/additional-page-carousel-section.component';
import { AdditionalPageEmergencyBannerComponent } from './component/page/group/addiotional-page/additional-page-emergency-banner/additional-page-emergency-banner.component';
import { AdditionalPageSectionComponent } from './component/page/group/addiotional-page/additional-page-section/additional-page-section.component';
import { AdditionalPageTableSectionComponent } from './component/page/group/addiotional-page/additional-page-table-section/additional-page-table-section.component';
import { APIReferenceErrorResponsesPageComponent } from './component/page/group/api-docs/api-reference-error-responses-page/api-reference-error-responses-page.component';
import { ApiReferenceMockScreenPageComponent } from './component/page/group/api-docs/api-reference-mock-screen-page/api-reference-mock-screen-page.component';
import { APIReferenceOverviewPageComponent } from './component/page/group/api-docs/api-reference-overview-page/api-reference-overview-page.component';
import { APIReferencePageComponent } from './component/page/group/api-docs/api-reference-page/api-reference-page.component';
import { ApiReferenceRegistrationPageComponent } from './component/page/group/api-docs/api-reference-registration-page/api-reference-registration-page.component';
import { APIReferenceRequestPageComponent } from './component/page/group/api-docs/api-reference-request-page/api-reference-request-page.component';
import { APIReferenceResponsePageComponent } from './component/page/group/api-docs/api-reference-response-page/api-reference-response-page.component';
import { APIReferenceV17dot2PageComponent } from './component/page/group/api-docs/api-reference-v17dot2-page/api-reference-v17dot2-page.component';
import { APIReferenceXmlSamplesPageComponent } from './component/page/group/api-docs/api-reference-xml-samples-page/api-reference-xml-samples-page.component';
import { CardPaymentAuthenticationPageComponent } from './component/page/group/api-docs/card-payment-authentication-page/card-payment-authentication-page.component';
import { CommonTypesDatalistsPageComponent } from './component/page/group/api-docs/common-types-datalists-page/common-types-datalists-page.component';
import { CreditCardAuthenticationPageComponent } from './component/page/group/api-docs/credit-card-authentication-page/credit-card-authentication-page.component';
import { FileAssetsPageComponent } from './component/page/group/api-docs/file-assets-page/file-assets-page.component';
import { FrequentTravellerAviosCardsPageComponent } from './component/page/group/api-docs/frequent-traveller-avios-cards-page/frequent-traveller-avios-cards-page.component';
import { FunctionalCapabilitiesDisruptionHandlingPageComponent } from './component/page/group/api-docs/functional-capabilities-disruption-handling-page/functional-capabilities-disruption-handling-page.component';
import { FunctionalCapabilitiesOcnAuthenticationPageComponent } from './component/page/group/api-docs/functional-capabilities-ocn-authentication-page/functional-capabilities-ocn-authentication-page.component';
import { FunctionalCapabilitiesOfferManagementPageComponent } from './component/page/group/api-docs/functional-capabilities-offer-management-page/functional-capabilities-offer-management-page.component';
import { FunctionalCapabilitiesOrderManagementPageComponent } from './component/page/group/api-docs/functional-capabilities-order-management-page/functional-capabilities-order-management-page.component';
import { GettingStartedPageComponent } from './component/page/group/api-docs/getting-started-page/getting-started-page.component';
import { IntroductionSandboxToolPageComponent } from './component/page/group/api-docs/introduction-sandbox-tool-page/introduction-sandbox-tool-page.component';
import { IntroductionToNdcPageComponent } from './component/page/group/api-docs/introduction-to-ndc-page/introduction-to-ndc-page.component';
import { LanguagesSupportedPageComponent } from './component/page/group/api-docs/languages-supported-page/languages-supported-page.component';
import { NdcProductUpdateNotificationsPageComponent } from './component/page/group/api-docs/ndc-product-update-notifications-page/ndc-product-update-notifications-page.component';
import { NdcSandboxToolGuidePageComponent } from './component/page/group/api-docs/ndc-sandbox-tool-guide-page/ndc-sandbox-tool-guide-page.component';
import { NewNdcRevisionNoticePageComponent } from './component/page/group/api-docs/new-ndc-revision-notice-page/new-ndc-revision-notice-page.component';
import { OfflineAirlinePageComponent } from './component/page/group/api-docs/offline-airline-page/offline-airline-page.component';
import { PaymentsPageComponent } from './component/page/group/api-docs/payments-page/payments-page.component';
import { RevisionNoticesPageComponent } from './component/page/group/api-docs/revision-notices-page/revision-notices-page.component';
import { TestCreditCardsPageComponent } from './component/page/group/api-docs/test-credit-cards-page/test-credit-cards-page.component';
import { ConnectingToNdcNdcCommercialFaqPageComponent } from './component/page/group/faq/connecting-to-ndc-ndc-commercial-faq-page/connecting-to-ndc-ndc-commercial-faq-page.component';
import { DisruptionNotificationsNdcTechnicalFaqPageComponent } from './component/page/group/faq/disruption-notifications-ndc-technical-faq-page/disruption-notifications-ndc-technical-faq-page.component';
import { ErrorResponseNdcTechnicalFaqPageComponent } from './component/page/group/faq/error-response-ndc-technical-faq-page/error-response-ndc-technical-faq-page.component';
import { NdcCommercialFaqPageComponent } from './component/page/group/faq/ndc-commercial-faq-page/ndc-commercial-faq-page.component';
import { NdcFeaturesSupportedInNdcNdcCommercialFaqPageComponent } from './component/page/group/faq/ndc-features-supported-in-ndc-ndc-commercial-faq-page/ndc-features-supported-in-ndc-ndc-commercial-faq-page.component';
import { NdcHelpdeskFaqPageComponent } from './component/page/group/faq/ndc-helpdesk-faq-page/ndc-helpdesk-faq-page.component';
import { NdcSupportFaqPageComponent } from './component/page/group/faq/ndc-support-faq-page/ndc-support-faq-page.component';
import { NdcTechnicalFaqPageComponent } from './component/page/group/faq/ndc-technical-faq-page/ndc-technical-faq-page.component';
import { PaymentsNdcCommercialFaqPageComponent } from './component/page/group/faq/payments-ndc-commercial-faq-page/payments-ndc-commercial-faq-page.component';
import { PricingAndTicketingNdcCommercialFaqPageComponent } from './component/page/group/faq/pricing-and-ticketing-ndc-commercial-faq-page/pricing-and-ticketing-ndc-commercial-faq-page.component';
import { IagBookingPortalsPageComponent } from './component/page/group/iag-portal/iag-booking-portals-page/iag-booking-portals-page.component';
import { IagPortalDisruptedBookingsPageComponent } from './component/page/group/iag-portal/iag-portal-disrupted-bookings-page/iag-portal-disrupted-bookings-page.component';
import { IagPortalFaqsPageComponent as IagPortalFaqsPageComponent } from './component/page/group/iag-portal/iag-portal-faqs-page/iag-portal-faqs-page.component';
import { IagPortalFeedbackAndSuggestionsPageComponent } from './component/page/group/iag-portal/iag-portal-feedback-and-suggestions-page/iag-portal-feedback-and-suggestions-page.component';
import { IagPortalHowDoIMakeABookingPageComponent } from './component/page/group/iag-portal/iag-portal-how-do-i-make-a-booking-page/iag-portal-how-do-i-make-a-booking-page.component';
import { IagPortalHowDoIServiceABookingPageComponent } from './component/page/group/iag-portal/iag-portal-how-do-i-service-a-booking-page/iag-portal-how-do-i-service-a-booking-page.component';
import { IagPortalHowDoesItWorkPageComponent } from './component/page/group/iag-portal/iag-portal-how-does-it-work-page/iag-portal-how-does-it-work-page.component';
import { IagPortalLoggingInPageComponent as IagPortalLoggingInPageComponent } from './component/page/group/iag-portal/iag-portal-logging-in-page/iag-portal-logging-in-page.component';
import { IagPortalProductUpdateNotificationsPageComponent } from './component/page/group/iag-portal/iag-portal-product-update-notifications-page/iag-portal-product-update-notifications-page.component';
import { IagPortalReportsPageComponent } from './component/page/group/iag-portal/iag-portal-reports-page/iag-portal-reports-page.component';
import { IagPortalRevisionNoticesComponent } from './component/page/group/iag-portal/iag-portal-revision-notices/iag-portal-revision-notices.component';
import { IagPortalRoadmapPageComponent as IagPortalRoadmapPageComponent } from './component/page/group/iag-portal/iag-portal-roadmap-page/iag-portal-roadmap-page.component';
import { IagPortalSupportPageComponent } from './component/page/group/iag-portal/iag-portal-support-page/iag-portal-support-page.component';
import { IagPortalUserManagementPageComponent } from './component/page/group/iag-portal/iag-portal-user-management-page/iag-portal-user-management-page.component';
import { IagPortalWhereDoIRegisterPageComponent } from './component/page/group/iag-portal/iag-portal-where-do-i-register-page/iag-portal-where-do-i-register-page.component';
import { NdcRegistrationManualPageComponent } from './component/page/group/iag-portal/ndc-registration-manual-page/ndc-registration-manual-page.component';
import { KnownIssuesContentComponent } from './component/page/group/known-issues/known-issues-content/known-issues-content.component';
import { KnownIssuesDetailsPageComponent } from './component/page/group/known-issues/known-issues-details-page/known-issues-details-page.component';
import { KnownIssuesJiraContentPageComponent } from './component/page/group/known-issues/known-issues-jira-content-page/known-issues-jira-content-page.component';
import { OperationalAssurancesInfoPageComponent } from './component/page/group/operational-assurances/operational-assurances-info-page/operational-assurances-info-page.component';
import { OperationalAssurancesKpiDefinitionsPageComponent } from './component/page/group/operational-assurances/operational-assurances-kpi-definitions-page/operational-assurances-kpi-definitions-page.component';
import { OperationalAssurancesNdcHealthCheckDashboardPageComponent } from './component/page/group/operational-assurances/operational-assurances-ndc-health-check-dashboard-page/operational-assurances-ndc-health-check-dashboard-page.component';
import { HomePageComponent } from './component/page/home-page/home-page.component';
import { IagPortalPageComponent } from './component/page/iag-portal-page/iag-portal-page.component';
import { KnownIssuesPageComponent } from './component/page/known-issues-page/known-issues-page.component';
import { NDCDevelopmentRoadmapPageComponent } from './component/page/ndc-development-roadmap-page/ndc-development-roadmap-page.component';
import { NDCHighLevelRoadmapPageComponent } from './component/page/ndc-high-level-roadmap-page/ndc-high-level-roadmap-page.component';
import { NDCOfferManagementCapabilitiesPageComponent } from './component/page/ndc-offer-management-capabilities-page/ndc-offer-management-capabilities-page.component';
import { NDCOrderManagementCapabilitiesPageComponent } from './component/page/ndc-order-management-capabilities-page/ndc-order-management-capabilities-page.component';
import { NdcProductApiRoadmapPageComponent } from './component/page/ndc-product-api-roadmap-page/ndc-product-api-roadmap-page.component';
import { NdcRegistrationPageComponent } from './component/page/ndc-registration-page/ndc-registration-page.component';
import { NewsContentPageComponent } from './component/page/news-content-page/news-content-page.component';
import { NewsPageComponent } from './component/page/news-page/news-page.component';
import { OperationalAssurancesPageComponent } from './component/page/operational-assurances-page/operational-assurances-page.component';
import { SandboxLogViewComponent } from './component/page/sandbox-log-view/sandbox-log-view.component';
import { SandboxPageComponent } from './component/page/sandbox-page/sandbox-page/sandbox-page.component';
import { SearchResultPageComponent } from './component/page/search-result-page/search-result-page.component';
import { ServiceStatusPageComponent } from './component/page/service-status-page/service-status-page.component';
import { ServiceTechnologyProvidersComponent } from './component/page/service-technology-providers/service-technology-providers.component';
import { SupportPageComponent } from './component/page/support-page/support-page.component';
import { ConfirmEmailRequestPageComponent } from './component/page/user/confirm-email-request-page/confirm-email-request-page.component';
import { ForgotPasswordPageComponent } from './component/page/user/forgot-password-page/forgot-password-page.component';
import { LoginPageComponent } from './component/page/user/login-page/login-page.component';
import { PasswordResetComponent } from './component/page/user/password-reset/password-reset.component';
import { passwordResetSuccessPageComponent } from './component/page/user/password-reset-success/password-reset-success.component';
import { ProfilePageComponent } from './component/page/user/profile-page/profile-page.component';
import { RegisterPageComponent } from './component/page/user/register-page/register-page.component';
import { UserRegistrationThankyouPageComponent } from './component/page/user/user-registration-thankyou-page/user-registration-thankyou-page.component';
import { ViewSandboxPageStateComponent } from './component/poc/view-sandbox-page-state/view-sandbox-page-state.component';
import { Xml2jsonComponent } from './component/poc/xml2json/xml2json.component';
import { AddAncilliariesScreenComponent } from './component/screen/add-ancilliaries-screen/add-ancilliaries-screen.component';
import { AddBaggageScreenComponent } from './component/screen/add-baggage-screen/add-baggage-screen.component';
import { AddMealScreenComponent } from './component/screen/add-meal-screen/add-meal-screen.component';
import { AddSeatsAncilliariesScreenComponent } from './component/screen/add-seats-ancilliaries-screen/add-seats-ancilliaries-screen.component';
import { AirlineOffersScreenComponent } from './component/screen/airline-offers-screen/airline-offers-screen.component';
import { ApiConnectionProfileScreenComponent } from './component/screen/api-connection-profile-screen/api-connection-profile-screen.component';
import { CancelBookingRefundQuoteScreenComponent } from './component/screen/cancel-booking-refund-quote-screen/cancel-booking-refund-quote-screen.component';
import { ChangeFlightDateTimeComponent } from './component/screen/change-flight-date-time/change-flight-date-time.component';
import { ConfirmBookingScreenComponent } from './component/screen/confirm-booking-screen/confirm-booking-screen.component';
import { DisruptedOrderViewerScreenComponent } from './component/screen/disrupted-order-viewer-screen/disrupted-order-viewer-screen.component';
import { FilterOffersScreenComponent } from './component/screen/filter-offers-screen/filter-offers-screen.component';
import { FindOrderScreenComponent } from './component/screen/find-order-screen/find-order-screen.component';
import { IssueTicketsScreenComponent } from './component/screen/issue-tickets-screen/issue-tickets-screen.component';
import { OfferPriceScreenComponent } from './component/screen/offer-price-screen/offer-price-screen.component';
import { OrderDetailsScreenComponent } from './component/screen/order-details-screen/order-details-screen.component';
import { PassengerDetailsScreenComponent } from './component/screen/passenger-details-screen/passenger-details-screen.component';
import { PassengerNameChangeScreenComponent } from './component/screen/passenger-name-change-screen/passenger-name-change-screen.component';
import { SearchFlightsScreenComponent } from './component/screen/search-flights-screen/search-flights-screen.component';
import { SeatSelectionScreenComponent } from './component/screen/seat-selection-screen/seat-selection-screen.component';
import { SplitBookingScreenComponent } from './component/screen/split-booking-screen/split-booking-screen.component';
import { XmlLogsScreenComponent } from './component/screen/xml-logs-screen/xml-logs-screen.component';
import { YourBookingScreenComponent } from './component/screen/your-booking-screen/your-booking-screen.component';
import { ApiReferenceAccordionSectionComponent } from './component/section/api-reference-accordion-section/api-reference-accordion-section.component';
import { ApiReferenceDetailsXmlSectionComponent } from './component/section/api-reference-details-xml-section/api-reference-details-xml-section.component';
import { ApiReferenceEndpointsTableSectionComponent } from './component/section/api-reference-endpoints-table-section/api-reference-endpoints-table-section.component';
import { ApiReferenceInterfaceDesignSectionComponent } from './component/section/api-reference-interface-design-section/api-reference-interface-design-section.component';
import { ApiReferenceIntroductionSectionComponent } from './component/section/api-reference-introduction-section/api-reference-introduction-section.component';
import { ApiReferenceNoteSectionComponent } from './component/section/api-reference-note-section/api-reference-note-section.component';
import { ApiReferenceRibbonTileSectionComponent } from './component/section/api-reference-ribbon-tile-section/api-reference-ribbon-tile-section.component';
import { ApiReferenceWebserviceSectionComponent } from './component/section/api-reference-webservice-section/api-reference-webservice-section.component';
import { ApiReferenceWsdlSectionComponent } from './component/section/api-reference-wsdl-section/api-reference-wsdl-section.component';
import { CommonModalComponent } from './component/section/common-modal/common-modal.component';
import { CommonTypesDatalistsAccordionSectionComponent } from './component/section/common-types-datalists-accordion-section/common-types-datalists-accordion-section.component';
import { CommonTypesDatalistsDetailsXmlSectionComponent } from './component/section/common-types-datalists-details-xml-section/common-types-datalists-details-xml-section.component';
import { CommonTypesDatalistsNoteSectionComponent } from './component/section/common-types-datalists-note-section/common-types-datalists-note-section.component';
import { FileAssetsNoteSectionComponent } from './component/section/file-assets-note-section/file-assets-note-section.component';
import { FileAssetsSectionComponent } from './component/section/file-assets-section/file-assets-section.component';
import { FunctionalCapabilitiesDisruptionHandlingStartRibbonTileSectionComponent } from './component/section/functional-capabilities-disruption-handling-start-ribbon-tile-section/functional-capabilities-disruption-handling-start-ribbon-tile-section.component';
import { HomePageAnnouncementsSectionComponent } from './component/section/home-page-announcements-section/home-page-announcements-section.component';
import { IagPortalAccordianSectionComponent } from './component/section/iag-portal-accordian-section/iag-portal-accordian-section.component';
import { IagPortalDetailsXmlSectionComponent } from './component/section/iag-portal-details-xml-section/iag-portal-details-xml-section.component';
import { NewRevisionNoticeAbstractSectionComponent } from './component/section/new-revision-notice-abstract-section/new-revision-notice-abstract-section.component';
import { NewRevisionNoticeDetailsSectionComponent } from './component/section/new-revision-notice-details-section/new-revision-notice-details-section.component';
import { NewRevisionNoticeXmlDataComponent } from './component/section/new-revision-notice-xml-data/new-revision-notice-xml-data.component';
import { NewsContentPageAccordionSectionComponent } from './component/section/news-content-page-accordion-section/news-content-page-accordion-section.component';
import { NewsContentPageNoteSectionComponent } from './component/section/news-content-page-note-section/news-content-page-note-section.component';
import { NewsContentPageSectionComponent } from './component/section/news-content-page-section/news-content-page-section.component';
import { NewsContentPageTableSectionComponent } from './component/section/news-content-page-table-section/news-content-page-table-section.component';
import { PaymentsRibbonTileSectionComponent } from './component/section/payments-ribbon-tile-section/payments-ribbon-tile-section.component';
import { RevisionNoticesAbstractSectionComponent } from './component/section/revision-notices-abstract-section/revision-notices-abstract-section.component';
import { RevisionNoticesAffectedApiFlowSectionComponent } from './component/section/revision-notices-affected-api-flow-section/revision-notices-affected-api-flow-section.component';
import { RevisionNoticesDetailsXmlSectionComponent } from './component/section/revision-notices-details-xml-section/revision-notices-details-xml-section.component';
import { RevisionNoticesNoteSectionComponent } from './component/section/revision-notices-note-section/revision-notices-note-section.component';
import { RevisionNoticesProductChangeNoticeSectionComponent } from './component/section/revision-notices-product-change-notice-section/revision-notices-product-change-notice-section.component';
import { RevisionNoticesUnorderedListWithXmlSectionComponent } from './component/section/revision-notices-unordered-list-with-xml-section/revision-notices-unordered-list-with-xml-section.component';
import { RevisionNoticesXmlModalSectionComponent } from './component/section/revision-notices-xml-modal-section/revision-notices-xml-modal-section.component';
import { ServiceTechnologyProvidersTableSectionComponent } from './component/section/service-technology-providers-table-section/service-technology-providers-table-section.component';
import { SupportPageOutageBannerSectionComponent } from './component/section/support-page-outage-banner-section/support-page-outage-banner-section.component';
import { AffectedApiFlowSectionComponent } from './component/shared/affected-api-flow-section/affected-api-flow-section.component';
import { ApiReferenceTableSectionComponent } from './component/shared/api-reference-table-section/api-reference-table-section.component';
import { BannerComponent } from './component/shared/banner/banner.component';
import { BorderSectionComponent } from './component/shared/border-section/border-section.component';
import { CommonTypesDatalistsTableSectionComponent } from './component/shared/common-types-datalists-table-section/common-types-datalists-table-section.component';
import { DefinitionXmlSectionComponent } from './component/shared/definition-xml-section/definition-xml-section.component';
import { DetailsXMLSectionComponent } from './component/shared/details-xml-section/details-xml-section.component';
import { ExpandImageSectionComponent } from './component/shared/expand-image-section/expand-image-section.component';
import { FileAssetsTableSectionComponent } from './component/shared/file-assets-table-section/file-assets-table-section.component';
import { FooterComponent } from './component/shared/footer/footer.component';
import { FunctionalCapabilitiesDetailsXmlSectionComponent } from './component/shared/functional-capabilities-details-xml-section/functional-capabilities-details-xml-section.component';
import { FunctionalCapabilitiesIntroductionSectionComponent } from './component/shared/functional-capabilities-introduction-section/functional-capabilities-introduction-section.component';
import { FunctionalCapabilitiesNoteSectionComponent } from './component/shared/functional-capabilities-note-section/functional-capabilities-note-section.component';
import { FunctionalCapabilitiesRibbonTileSectionComponent } from './component/shared/functional-capabilities-ribbon-tile-section/functional-capabilities-ribbon-tile-section.component';
import { FunctionalCapabilitiesTableSectionComponent } from './component/shared/functional-capabilities-table-section/functional-capabilities-table-section.component';
import { HeaderComponent } from './component/shared/header/header.component';
import { KnownIssuesSectionComponent } from './component/shared/known-issues-section/known-issues-section.component';
import { KnownIssuesTableSectionComponent } from './component/shared/known-issues-table-section/known-issues-table-section.component';
import { LeftSideMenuAdminControlComponent } from './component/shared/left-side-menu-admin-control/left-side-menu-admin-control.component';
import { LeftSideMenuApiComponent } from './component/shared/left-side-menu-api/left-side-menu-api.component';
import { LeftSideMenuIagPortalComponent } from './component/shared/left-side-menu-iag-portal/left-side-menu-iag-portal.component';
import { LeftSideMenuKnownIssuesComponent } from './component/shared/left-side-menu-known-issues/left-side-menu-known-issues.component';
import { LeftSideMenuOperationalAssurancesComponent } from './component/shared/left-side-menu-operational-assurances/left-side-menu-operational-assurances.component';
import { ModalComponent, PrismXMLDirective } from './component/shared/modal/modal.component';
import { NdcProductUpdateNotificationsPageTableSectionComponent } from './component/shared/ndc-product-update-notifications-page-table-section/ndc-product-update-notifications-page-table-section.component';
import { NewRoadmapSectionComponent } from './component/shared/new-roadmap-section/new-roadmap-section.component';
import { NoteComponent } from './component/shared/note/note.component';
import { OfflineAirlineProfileTableSectionComponent } from './component/shared/offline-airline-profile-table-section/offline-airline-profile-table-section.component';
import { OperationalAssurancesSectionComponent } from './component/shared/operational-assurances-section/operational-assurances-section.component';
import { OperationalAssurancesTableSectionComponent } from './component/shared/operational-assurances-table-section/operational-assurances-table-section.component';
import { PageLoaderComponent } from './component/shared/page-loader/page-loader.component';
import { PassengerDetailsComponent } from './component/shared/passenger-details/passenger-details.component';
import { PrismXmlComponent } from './component/shared/prism-xml/prism-xml.component';
import { ProductChangeNoticeSectionComponent } from './component/shared/product-change-notice-section/product-change-notice-section.component';
import { RoadmapSectionComponent } from './component/shared/roadmap-section/roadmap-section.component';
import { SectionComponent } from './component/shared/section/section.component';
import { SocialLinksComponent } from './component/shared/social-links/social-links.component';
import { TableSectionComponent } from './component/shared/table-section/table-section.component';
import { TopMenuComponent } from './component/shared/top-menu/top-menu.component';
import { VersionComponent } from './component/version/version.component';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { MdToHtmlPipe } from './pipe/md-to-html.pipe';
import { SearchHighlighterPipe } from './pipe/search-highlighter.pipe';
import { AppAdditionalRoutingModule } from './routing/app-additional-routing.module';
import { AppApiDocsRoutingModule } from './routing/app-api-docs-routing.module';
import { AppApiInfoRoutingModule } from './routing/app-api-info-routing.module';
import { AppConnectRoutingModule } from './routing/app-connect-routing.module';
import { AppFaqRoutingModule } from './routing/app-faq-routing.module';
import { AppFormsRoutingModule } from './routing/app-forms-routing.module';
import { AppHomeRoutingModule } from './routing/app-home-routing.module';
import { AppIagPortalRoutingModule } from './routing/app-iag-portal-routing.module';
import { AppInvalidRoutingModule } from './routing/app-invalid-routing.module';
import { AppNewsRoutingModule } from './routing/app-news-routing.module';
import { AppSandboxRoutingModule } from './routing/app-sandbox-routing.module';
import { AppNewSandboxRoutingModule } from './routing/app-sandbox-21.3-routing.module';
import { AppSupportRoutingModule } from './routing/app-support-routing.module';
import { AppUserRoutingModule } from './routing/app-user-routing.module';
import { ContentfulService } from './service/contentful.service';
import { ApiService } from './service/api.service';
import { GoogleAnalyticsService } from './service/google-analytics.service';
import { HighlightService } from './service/highlight.service';
import { LocalAssetReaderService } from './service/local-asset-reader.service';
import { ModalService } from './service/modal.service';
import { PageContentSearchService } from './service/page-content-search.service';
import { PageLoaderService } from './service/page-loader.service';
import { PageVersionService } from './service/page-version.service';
import { SandboxPageStateService } from './service/sandbox-page-state.service';
import { SharedDataService } from './service/shared-data.service';
import { XmlToJsonParserService } from './service/xml-to-json-parser.service';


import { MsalModule, MsalRedirectComponent, MsalGuard, MsalInterceptor, MsalService, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG,MsalInterceptorConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, IPublicClientApplication,BrowserCacheLocation } from '@azure/msal-browser';
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.azureAd.clientId,
      authority: config.azureAd.authority,
      redirectUri: config.azureAd.redirectUri,
      postLogoutRedirectUri: config.azureAd.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['openid', 'profile', 'email', 'user.read']);
  
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}
export function MSALInitFactory(msalService: MsalService) {
  return async () => {
    await msalService.instance.initialize();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    MdToHtmlPipe,
    DateFormatPipe,
    HomePageComponent,
    NewsPageComponent,
    APIInformationPageComponent,
    Ndc21ApiReferenceComponent,
    APIInformationCardComponent,
    UserCardComponent,
    CreditVoucherCardComponent,
    NewsSectionCardComponent,
    UsefulLinkCardComponent,
    NewsUpdateCardComponent,
    LoggingInCardComponent,
    NdcRegistrationCardComponent,
    WhereDoIRegisterCardComponent,
    NdcRegistrationsSaleshubCardComponent,
    FooterComponent,
    TopMenuComponent,
    LeftSideMenuApiComponent,
    LeftSideMenuIagPortalComponent,
    SupportPageComponent,
    FaqPageComponent,
    NdcTechnicalFaqPageComponent,
    DisruptionNotificationsNdcTechnicalFaqPageComponent,
    ConnectingToNdcNdcCommercialFaqPageComponent,
    ErrorResponseNdcTechnicalFaqPageComponent,
    NdcCommercialFaqPageComponent,
    NdcFeaturesSupportedInNdcNdcCommercialFaqPageComponent,
    NdcHelpdeskFaqPageComponent,
    NdcSupportFaqPageComponent,
    PricingAndTicketingNdcCommercialFaqPageComponent,
    BannerComponent,
    SectionComponent,
    BorderSectionComponent,
    AffectedApiFlowSectionComponent,
    IagPortalAccordianSectionComponent,
    DetailsXMLSectionComponent,
    DefinitionXmlSectionComponent,
    SocialLinksComponent,
    ProductChangeNoticeSectionComponent,
    ApiDocsPageComponent,
    APIReferenceV17dot2PageComponent,
    GettingStartedPageComponent,
    NdcSandboxToolGuidePageComponent,
    PaymentsPageComponent,
    TestCreditCardsPageComponent,
    CreditCardAuthenticationPageComponent,
    FrequentTravellerAviosCardsPageComponent,
    LanguagesSupportedPageComponent,
    TableSectionComponent,
    NoteComponent,
    HeaderComponent,
    BenefitCardComponent,
    NdcRegistrationPageComponent,
    NDCOfferManagementCapabilitiesPageComponent,
    NDCOrderManagementCapabilitiesPageComponent,
    NDCHighLevelRoadmapPageComponent,
    NdcProductApiRoadmapPageComponent,
    SupportCardComponent,
    RevisionNoticesPageComponent,
    IagPortalPageComponent,
    IagBookingPortalsPageComponent,
    IagPortalRoadmapPageComponent,
    IagPortalFaqsPageComponent,
    IagPortalReportsPageComponent,
    IagPortalLoggingInPageComponent,
    IagPortalSupportPageComponent,
    IagPortalFeedbackAndSuggestionsPageComponent,
    IagPortalHowDoIMakeABookingPageComponent,
    IagPortalHowDoIServiceABookingPageComponent,
    IagPortalWhereDoIRegisterPageComponent,
    IagPortalUserManagementPageComponent,
    IagPortalDisruptedBookingsPageComponent,
    FaqCardComponent,
    FileAssetsPageComponent,
    OfflineAirlinePageComponent,
    PrismXmlComponent,
    IagPortalHowDoesItWorkPageComponent,
    ApiReferenceAccordionSectionComponent,
    ApiReferenceDetailsXmlSectionComponent,
    RevisionNoticesDetailsXmlSectionComponent,
    ExpandImageSectionComponent,
    IagPortalDetailsXmlSectionComponent,
    IntroductionToNdcPageComponent,
    IntroductionSandboxToolPageComponent,
    PaymentsNdcCommercialFaqPageComponent,
    RevisionNoticesUnorderedListWithXmlSectionComponent,
    RevisionNoticesXmlModalSectionComponent,
    RevisionNoticesAbstractSectionComponent,
    ApiReferenceTableSectionComponent,
    RevisionNoticesAffectedApiFlowSectionComponent,
    RevisionNoticesProductChangeNoticeSectionComponent,
    NdcProductUpdateNotificationsPageComponent,
    NdcProductUpdateNotificationsPageTableSectionComponent,
    ApiReferenceRibbonTileSectionComponent,
    ApiReferenceIntroductionSectionComponent,
    ApiReferenceInterfaceDesignSectionComponent,
    ApiReferenceWsdlSectionComponent,
    ApiReferenceWebserviceSectionComponent,
    ApiReferenceNoteSectionComponent,
    ApiReferenceEndpointsTableSectionComponent,
    APIReferenceOverviewPageComponent,
    APIReferenceRequestPageComponent,
    APIReferenceResponsePageComponent,
    APIReferenceXmlSamplesPageComponent,
    APIReferenceErrorResponsesPageComponent,
    APIReferencePageComponent,
    APIReferenceManagementCardComponent,
    ApiReferenceRegistrationPageComponent,
    CommonTypesDatalistsPageComponent,
    CardPaymentAuthenticationPageComponent,
    CommonTypesDatalistsAccordionSectionComponent,
    CommonTypesDatalistsDetailsXmlSectionComponent,
    CommonTypesDatalistsTableSectionComponent,
    PageLoaderComponent,
    ModalComponent,
    PrismXMLDirective,
    FileAssetsTableSectionComponent,
    OfflineAirlineProfileTableSectionComponent,
    CommonTypesDatalistsNoteSectionComponent,
    FunctionalCapabilitiesOfferManagementPageComponent,
    FunctionalCapabilitiesOrderManagementPageComponent,
    FunctionalCapabilitiesDisruptionHandlingPageComponent,
    NewsContentPageComponent,
    FunctionalCapabilitiesIntroductionSectionComponent,
    FunctionalCapabilitiesNoteSectionComponent,
    FunctionalCapabilitiesTableSectionComponent,
    FunctionalCapabilitiesRibbonTileSectionComponent,
    FunctionalCapabilitiesDetailsXmlSectionComponent,
    PaymentsRibbonTileSectionComponent,
    NewsContentPageSectionComponent,
    NewsContentPageNoteSectionComponent,
    NewsContentPageAccordionSectionComponent,
    NewsContentPageTableSectionComponent,
    FunctionalCapabilitiesIntroductionSectionComponent,
    FunctionalCapabilitiesDisruptionHandlingStartRibbonTileSectionComponent,
    FileAssetsSectionComponent,
    FileAssetsNoteSectionComponent,
    SearchResultPageComponent,
    SearchHighlighterPipe,
    SupportPageOutageBannerSectionComponent,
    HomePageAnnouncementsSectionComponent,
    RoadmapSectionComponent,
    NewRoadmapSectionComponent,
    LoginPageComponent,
    RegisterPageComponent,
    ForgotPasswordPageComponent,
    NdcCreditVoucherRedemptionPageComponent,
    NdcCreditVoucherIssuancePageComponent,
    OrderChangeNotifRegistrationPageComponent,
    ProfilePageComponent,
    ConfirmEmailRequestPageComponent,
    passwordResetSuccessPageComponent,
    ServiceStatusPageComponent,
    PasswordResetComponent,
    SandboxPageComponent,
    Xml2jsonComponent,
    AirlineOffersScreenComponent,
    PassengerDetailsScreenComponent,
    PassengerNameChangeScreenComponent,
    YourBookingScreenComponent,
    PassengerDetailsComponent,
    FilterOffersScreenComponent,
    FindOrderScreenComponent,
    IssueTicketsScreenComponent,
    SearchFlightsScreenComponent,
    OfferPriceScreenComponent,
    XmlLogsScreenComponent,
    SandboxLogViewComponent,
    AddAncilliariesScreenComponent,
    AddBaggageScreenComponent,
    AddMealScreenComponent,
    AddSeatsAncilliariesScreenComponent,
    ConfirmBookingScreenComponent,
    RevisionNoticesNoteSectionComponent,
    SplitBookingScreenComponent,
    SeatSelectionScreenComponent,
    ChangeFlightDateTimeComponent,
    CancelBookingRefundQuoteScreenComponent,
    UserRegistrationThankyouPageComponent,
    LeftSideMenuOperationalAssurancesComponent,
    OperationalAssurancesNdcHealthCheckDashboardPageComponent,
    OperationalAssurancesInfoPageComponent,
    OperationalAssurancesKpiDefinitionsPageComponent,
    OperationalAssurancesPageComponent,
    NdcVoucherLogsPageComponent,
    LeftSideMenuAdminControlComponent,
    OperationalAssurancesTableSectionComponent,
    OperationalAssurancesSectionComponent,
    ApiConnectionProfileScreenComponent,
    ViewSandboxPageStateComponent,
    VersionComponent,
    FunctionalCapabilitiesOcnAuthenticationPageComponent,
    NdcRegistrationManualPageComponent,
    NdcRegistrationManualCardComponent,
    AdditionalContentPageComponent,
    ConnectPageComponent,
    ConnectCardComponent,
    ServiceTechnologyProvidersComponent,
    ServiceTechnologyProvidersTableSectionComponent,
    AdditionalPageSectionComponent,
    AdditionalPageAccordianSectionComponent,
    AdditionalPageTableSectionComponent,
    AdditionalPageEmergencyBannerComponent,
    AdditionalPageCarouselSectionComponent,
    AdditionalSectionCardComponent,
    NewNdcRevisionNoticePageComponent,
    NewRevisionNoticeXmlDataComponent,
    NewRevisionNoticeAbstractSectionComponent,
    NewRevisionNoticeDetailsSectionComponent,
    ContactUsPageComponent,
    SurerouteTestObjectComponent,
    DisruptedOrderViewerScreenComponent,
    ConnectCardComponent,
    KnownIssuesPageComponent,
    LeftSideMenuKnownIssuesComponent,
    KnownIssuesContentComponent,
    KnownIssuesSectionComponent,
    KnownIssuesTableSectionComponent,
    IagPortalProductUpdateNotificationsPageComponent,
    IagPortalRevisionNoticesComponent,
    OrderDetailsScreenComponent,
    FileUploadComponent,
    ConsentMoreinfoPageComponent,
    CookiesPolicyPageComponent,
    KnownIssuesJiraContentPageComponent,
    KnownIssuesDetailsPageComponent,
    ApiReferenceMockScreenPageComponent,
    NDCDevelopmentRoadmapPageComponent,
    CommonModalComponent
  ],
  imports: [
    MsalModule,
    MsalModule.forRoot(
      MSALInstanceFactory(),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['openid', 'profile', 'email', 'user.read']
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map()
      }
    ),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    AppInvalidRoutingModule,
    AppHomeRoutingModule,
    AppNewsRoutingModule,
    AppApiInfoRoutingModule,
    AppApiDocsRoutingModule,
    AppSupportRoutingModule,
    AppIagPortalRoutingModule,
    AppFaqRoutingModule,
    AppConnectRoutingModule,
    BrowserAnimationsModule,
    AppUserRoutingModule,
    AppFormsRoutingModule,
    NgxIntlTelInputModule,
    NgToggleModule,

    AppSandboxRoutingModule,
    AppNewSandboxRoutingModule,
    AppAdditionalRoutingModule,

    NgMultiSelectDropDownModule.forRoot(),
    NgxSliderModule,
    AutocompleteLibModule,
    NgbModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: config.enableServiceWorker,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: MSALInitFactory,
      deps: [MsalService],
      multi: true
    },
     {
       provide: MSAL_INSTANCE,
       useFactory: MSALInstanceFactory
     },
     {
       provide: MSAL_INTERCEPTOR_CONFIG,
       useFactory: MSALInterceptorConfigFactory
     },
    
    MsalService,
    MsalGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    // { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    XmlToJsonParserService,
    ContentfulService,
    PageContentSearchService,
    SharedDataService,
    PageVersionService,
    PageLoaderService,
    HighlightService,
    SandboxPageStateService,
    ApiService,
    LocalAssetReaderService,
    NgForm,
    DateFormatPipe,    
    ModalService,
    GoogleAnalyticsService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
